import { ca } from '@cian/analytics';

export function trackBannerClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click_sopr',
    label: 'independent_banner',
  });
}
